import { PayloadAction, Slice, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { User, UserState } from './user.types';
import { setCookie } from '@src/utilities/cookie';
import { COOKIES } from '@src/constants/cookies';

export const initialState: UserState = {
  user: null,
};

export const userSlice: Slice<UserState> = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
      setCookie(COOKIES.LOGGED_IN.NAME, 'false', 1);
    },
    setNewToken: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken?: string;
        idToken?: string;
        expiresIn?: number;
      }>
    ) => {
      if (state.user) {
        state.user.accessToken = action.payload.accessToken;

        if (action.payload.refreshToken) {
          state.user.refreshToken = action.payload.refreshToken;
        }

        if (action.payload.idToken) {
          state.user.idToken = action.payload.idToken;
        }

        if (action.payload.expiresIn) {
          state.user.expiresIn = action.payload.expiresIn;
        }
        setCookie(
          COOKIES.LOGGED_IN.NAME,
          'true',
          action.payload.expiresIn ?? COOKIES.LOGGED_IN.DURATION_SECONDS
        );
      }
    },
  },
});

export const { setUser, logout, setNewToken } = userSlice.actions;
export const selectCurrentUser = (state: RootState) => state.user.user;
export default userSlice.reducer;
